import * as React from 'react';
import { GlobalHeaderButton } from '@salesforce/design-system-react';
import './header.css';

const Header = ({className, onClick}: {className: string, onClick: () => void}) => (
	<header className={`slds-global-header_container ${className}`}>
		<div className="slds-global-header slds-grid slds-grid_align-spread">
			<div className="slds-global-header__item">
				{/*<h1 className="slds-text-heading_medium slds-float_left">Customer 360 Data Manager</h1>*/}
				<div className="slds-global-header__logo" onClick={onClick} />
			</div>

			<ul className="slds-global-header__item slds-grid slds-grid_vertical-align-center">
				<GlobalHeaderButton
					assistiveText={{ icon: 'Help and Training' }}
					iconName="question"
					onClick={() => { return; }}
				/>
				<GlobalHeaderButton
					assistiveText={{ icon: 'Setup' }}
					iconName="settings"
					onClick={() => { return; }}
				/>
				<GlobalHeaderButton
					assistiveText={{ icon: 'Notification' }}
					iconName="notification"
					onClick={() => { return; }}
				/>

				<li className="slds-dropdown-trigger slds-dropdown-trigger_click slds-m-left_x-small">
					<button className="slds-button" title="person name" aria-haspopup="true">
						<span className="slds-avatar slds-avatar_circle slds-avatar_medium">
							<img alt="Person name" src="/assets/images/avatar.png" title="User avatar" />
						</span>
					</button>
				</li>
			</ul>
		</div>
	</header>
);

export default Header;


// WEBPACK FOOTER //
// ./src/Header/index.tsx